import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Injectable()
export class MktSEOService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private metaService: Meta,
    @Inject(DOCUMENT) private _document: any
  ) { }


  // Take Contentful SEO Tags content model and create the proper meta, link, and schema tags
  setContentfulSeoTags(contentfulSeoTags) {
    const contentfulMetaTags = contentfulSeoTags.metaTags || [];
    const contentfulLinkTags = contentfulSeoTags.linkTags || [];
    const contentfulSchemaTags = contentfulSeoTags.schemaTags || [];

    // Set meta tags
    let formattedMetaTagArray = [];
    for (let i = 0; i < contentfulMetaTags.length; i++) {
      formattedMetaTagArray[i] = {
        'name': contentfulMetaTags[i]['tagName'],
        'content': contentfulMetaTags[i]['content']
      };

      // Remove old meta tags
      this.removeAllDomElements(`meta[name="${contentfulMetaTags[i]?.tagName}"]`)
    }
    this.metaService.addTags(formattedMetaTagArray);

    // Set link tags
    for (let i = 0; i < contentfulLinkTags.length; i++) {
      let element = this._document.createElement('link');
      element['rel'] = contentfulLinkTags[i]['rel'];

      // Remove old link tags
      this.removeAllDomElements(`link[rel="${element['rel']}"]`)

      element['href'] = contentfulLinkTags[i]['href'];
      this._document.getElementsByTagName("head")[0].appendChild(element);
    }

    if (contentfulSchemaTags.length) {
      //  Remove old Schema tags
      this.removeAllDomElements(`script[type="application/ld+json"]`)
    }

    // Set schema tags
    for (let i = 0; i < contentfulSchemaTags.length; i++) {

      let element = this._document.createElement('script');
      element['type'] = 'application/ld+json';
      element['text'] = JSON.stringify(contentfulSchemaTags[i]['schemaJson']);
      element['nonce'] = "CSP_NONCE_PLACEHOLDER";
      this._document.getElementsByTagName("head")[0].appendChild(element);
    }
  }

  private removeAllDomElements(querySelector: string) {
    if (!isPlatformBrowser(this.platformId)) return;

    (this._document || document).querySelectorAll(querySelector).forEach(elem => elem.remove());
  }

  // TODO: Temporarily used for the CKC pages that aren't using Contentful
  setSEOTags(SEOTags) {
    this.setMetaTags(SEOTags.metaTagArray);
    this.setCustomTags(SEOTags.customTagArray);
  }

  setMetaTags(metaTagArray) {
    this.metaService.addTags(metaTagArray);
  }

  setCustomTags(customTagArray) {
    for (let customTag of customTagArray) {
      let element = this._document.createElement(customTag.elementType);

      if (customTag.properties) {
        for (const [propertyName, propertyValue] of Object.entries(customTag.properties)) {
          element[propertyName] = propertyValue;
        }
      }

      if (customTag.innerHTMLJson) { element.text = JSON.stringify(customTag.innerHTMLJson); }

      this._document.getElementsByTagName("head")[0].appendChild(element);
    }
  }
}